import { type appConfigType, type appPermissions } from 'shared/platforms/platformTypes';
// import { router } from 'src/main';

// @ts-expect-error somehow this isnt properly loaded, it does work
import { config } from '@platform/config';
import { redirect } from '@tanstack/react-router';
export const appConfig: appConfigType = config;

export function isRouteAllowed(...requiredPermissions: (keyof appPermissions)[]) {
	const isAllowed = requiredPermissions.every((p) => appConfig.permissions[p]);

	if (!isAllowed) {
		console.warn('Platform does not have permissions to access this page');
		// router.history.back();
		throw redirect({
			to: '/',
		});
	}
}
